import { useCallback, useState } from "react";
import type { QrProducto } from "../types/catalogoInventario.types";
import { generarQrProducto } from "../utils/catalogoInventarioOperaciones.utils";

interface Opciones {
    idUsuario: number;
    onError: (error: unknown) => void;
    /** Para que el catálogo actualice la fila sin recargar */
    onGenerado: (qr: QrProducto) => void;
}

export const useQrProducto = (
    qrInicial: QrProducto | null,
    { idUsuario, onError, onGenerado }: Opciones
) => {
    const [qr, setQr] = useState<QrProducto | null>(qrInicial);
    const [generando, setGenerando] = useState(false);

    const generar = useCallback(
        async (idInventario: number) => {
            if (qr) return; // un solo QR por producto
            try {
                setGenerando(true);
                const nuevo = await generarQrProducto(idInventario, idUsuario);
                setQr(nuevo);
                onGenerado(nuevo);
            } catch (error) {
                onError(error);
            } finally {
                setGenerando(false);
            }
        },
        [qr, idUsuario, onError, onGenerado]
    );

    return { qr, generando, generar, tieneQr: qr !== null };
};
